import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import jwtEncode from "jwt-encode";
import FormController from "./FormController/formController";
import Login from "./Authentication/Login";
import BuyNow from "./Authentication/Buynow";
import SimulanisLogin from "./Authentication/SimulanisLogin";
import LeftNavBar from "./Navbar/LeftNavbar";
import TopNavBar from "./Navbar/TopNavBar";
import SiteDashBoard from "./FormController/Dashboard/SiteDashboard";
import DashboardController from "./FormController/dashboardController";
import CallingChannel from "./FormController/VideoChat/CallingChannel";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/icons.css";
import "./assets/css/style.css";
import "./assets/css/style_custom.css";
import "./assets/css/lightdarkmode.css";
import {
  jwt,
  ud,
  SERVER_IP,
  PORT,
  changeUserInfo,
  Communication_obj,
  auth_response_flow,
  UpdateLicense,
  redirectUrl,
  applicationId,
  UNO_URL,
} from "./Server";
import { SOCKET, UpdateSocket } from "./SocketData";
import AcessDenied from "./FormController/SplashPage/AcessDenied";
import Authloading from "./FormController/SplashPage/authLoading";
import axios from "axios";
import Projects from "./FormController/Projects/project";
import UserState from "./context/UserState";
import { Videocall, Audiocall } from "./FormController/VideoChat/Call";
import swal from "sweetalert";
import FullScreenLoader from "./FullScreenLoader/fullScreenLoader";
// import socketIo from "socket.io-client";
import NewCall from "./FormController/Iframe/NewCall";
import AlignedWorkflow from "./FormController/Workflow/AlignedWorkflow";
import CreateWorkflow from "./FormController/Workflow/WorkflowList";
import ListSAdmin from "./FormController/S_Admin/ListSAdmin";
import callStastistics from "./FormController/CallStastistics/callStastistics";
import WorkflowMoblie from "./FormController/Workflow/WorkflowMoblie";
import AssignedWorkedFlow from "./FormController/Workflow/AssignedWorkedFlowMobile";
import { DASHBOARD_PERMISSION, HOME_PERMISSION, WORKFLOW_BUILDER_PERMISSION } from "./constant/constant";
import userDashboard from "./FormController/Dashboard/userDashboard";
import AssignedWorkFlowList from "./FormController/Workflow/AssignedWorkFlowList";
import Folders from "./FormController/Files/Folders";
import FilesList from "./FormController/Files/FilesList";

const AppRoutes = ({ socket, toCalling, liveusers }) => {
  const user = useSelector((state) => state.userData);
  const { userDetails } = user;
  const [permissionList, setPermissionList] = useState([]);

  useEffect(() => {
    setPermissionList(userDetails?.user?.permissions || []);
  }, [userDetails]);

  return (
    <>
      {jwt ? (
        <>
          <Switch>
            {permissionList.includes(HOME_PERMISSION) && <Route exact path="/" component={EmptyComponent} />}
            {permissionList.includes(DASHBOARD_PERMISSION) && (
              <Route path="/dashboard/:uuid" component={userDashboard} />
            )}
            {/* <Route path="/team/dashboard" component={SiteDashBoard} /> */}
            <Route exact path="/team/dashboard/:id" component={AlignedWorkflow} />
            <Route exact path="/my/activity/:uuid" component={AssignedWorkFlowList} />
            {permissionList.includes(WORKFLOW_BUILDER_PERMISSION) && (
              <Route path="/workflow/author" component={CreateWorkflow} />
            )}
            <Route path="/files/:type/:uuid" component={FilesList} />
            <Route path="/files" component={Folders} />
            <Route
              exact
              path="/create/:formtype"
              component={(props) => <FormController {...props} socket={socket} toCalling={toCalling} />}
            />
            <Route path="*">
              {" "}
              <Redirect to="/" />{" "}
            </Route>
          </Switch>

          {/* <Route path="/workflow/1" component={WorkflowMoblie} />  */}
          {/* <Route path="/workflow/2" component={AssignedWorkedFlow} /> */}
          {/* <Route path="/create/callstaistics" component={callStastistics} /> */}
          {/* <Route path="*"> <Redirect to="/" /> </Route> */}
          {/* <Route path="/call/:room_id"> <Audiocall socket={socket} liveusers={liveusers} /> </Route> */}
          {/* <Route path="*"><Redirect to="/newcall" /> </Route> */}
        </>
      ) : (
        <>
          {/* <Route path="/" component={Login} exact /> */}
          {/* <Route path="/buynow" component={BuyNow} />
          <Route path="/login" component={Login} />
          <Route path="/simulanislogin" component={SimulanisLogin} />
          <Route path="/projects" component={Projects} /> */}
        </>
      )}
    </>
  );
};

export default AppRoutes;
const EmptyComponent = () => {
  return <></>;
};